import { render, staticRenderFns } from "./partnerStartup.vue?vue&type=template&id=fd3c364a&scoped=true&"
import script from "./partnerStartup.vue?vue&type=script&lang=js&"
export * from "./partnerStartup.vue?vue&type=script&lang=js&"
import style0 from "./partnerStartup.vue?vue&type=style&index=0&id=fd3c364a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd3c364a",
  null
  
)

export default component.exports